<template>
  <div v-if="calibrationHandler.state.initCalibrationStatus == false" class="calibration_skip" @click="skipClick">
    {{ $t('skip') }}
    <img class="skip_img" src="../../assets/img/skip.svg" alt="" />
  </div>
</template>

<script setup lang="ts">
import { DialogType, enableDialog } from '../cdialog/dialog'
import { calibrationHandler } from '../../service/driver/calibration_set'
import { DriverService } from '@/service/driver/driver'
import i18n from '@/languages/i18n'
let { t } = i18n.global
const skipClick = () => {
  enableDialog(t('calibration_message'), DialogType.confirm).then(async (confirm: boolean) => {
    if (confirm) {
      if (calibrationHandler.isWitmodVendor() == true) {
        await calibrationHandler.calibrationAllKeys(false)
        calibrationHandler.state.isShowExeAllCalibration = false
      } else {
        // 晶泰 和 royuan 方案
        await calibrationHandler.calibrationAllKeys(false)
        await calibrationHandler.endAllKeysWatchTrave()
        calibrationHandler.state.isShowHidCalibration = false
      }
      calibrationHandler.markCalibrationSuccess()
      // 校准/跳过结束，补充执行 initializeDevice 期间因校准页显示而跳过的全部设备初始化
      await DriverService.instance.completePostCalibrationInit()
      setTimeout(() => {
        enableDialog(t('calculator_cancel'))
      }, 10)
    }
  })
}
</script>

<style scoped lang="less">
.calibration_skip {
  margin-top: 30px;
  font-size: 24px;
  height: 30px;
  color: rgba(#fff, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  .skip_img {
    margin-top: 5px;
    height: 20px;
    width: 20px;
    margin-left: 10px;
  }
}
</style>
